import Container from '~/components/container/Container';
import NoContent from '~/components/noContent/NoConTent';

function AlbumVpop() {
    return (
        <Container>
            <NoContent />
        </Container>
    );
}

export default AlbumVpop;
